import { Observable } from 'rxjs';
import { config } from '../../config/config';
import { utilService } from '../utils';

export const ApiService = {
  apiRequest,
};

function apiRequest(url, request_json) {
  return Observable.create((observer) => {
    fetch(url, request_json)
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
